module.exports = __webpack_public_path__ + "static/media/get-refund-icon.8b69135a.svg";


//////////////////
// WEBPACK FOOTER
// ./packages/smart-home-support/assets/resources/SHS-SPRINT/get-refund-icon.svg
// module id = 2657
// module chunks = 0